module.exports = __webpack_public_path__ + "static/austravel-ffd5a699bd4560778fb084bffd084931.jpg";